export const panelHeaderStyles = {
  panelHeader: "flex flex-col gap-(--spacing-2)",
} as const;
